import { graphql } from "@/config/graphql";
import { useQuery } from "@apollo/client";
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Skeleton,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useMemo, useState } from "react";
const currentUserQuery = graphql(`
  query currentUser {
    currentUser {
      id
      name
      email
      plants {
        plant {
          id
          name
        }
        permission
      }
      selectedPlant {
        plant {
          id
          name
        }
      }
    }
  }
`);
export const PlantSelector = () => {
  const [changingPlant, setChangingPlant] = useState(false);
  const { data, loading, client, refetch } = useQuery(currentUserQuery);
  const selectedPlant = data?.currentUser?.selectedPlant?.plant;
  const allowedPlants = useMemo(
    () => data?.currentUser?.plants?.map((p) => p.plant) ?? [],
    [data?.currentUser?.plants]
  );
  const onChangePlant = async (e: SelectChangeEvent<number>) => {
    setChangingPlant(true);
    try {
      localStorage.setItem("plantid", String(e.target.value));
      await client.resetStore();
      await refetch();
    } finally {
      setChangingPlant(false);
    }
  };
  useEffect(() => {
    if (loading) return;
    if (!data?.currentUser) return;
    const selectedPlantId = localStorage.getItem("plantid");
    if (
      allowedPlants.length === 1 &&
      selectedPlant?.id !== Number(selectedPlantId)
    ) {
      localStorage.setItem("plantid", String(allowedPlants[0].id));
      client.resetStore();
      return;
    }
    const allowedPlantsIds = allowedPlants.map((p) => p.id);
    if (
      !selectedPlantId ||
      !allowedPlantsIds.includes(Number(selectedPlantId))
    ) {
      localStorage.setItem("plantid", String(allowedPlants[0].id));
      return;
    }
  }, [allowedPlants, client, loading, selectedPlant?.id]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h6" component="div" sx={{ lineHeight: 1.1 }}>
        {loading || changingPlant ? (
          <Skeleton
            width={120}
            variant="text"
            sx={{ bgcolor: grey[400], opacity: 0.5 }}
          />
        ) : allowedPlants.length > 1 ? (
          <Select
            value={selectedPlant?.id}
            onChange={onChangePlant}
            variant="outlined"
            size="small"
            sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
          >
            {allowedPlants.map((plant) => (
              <MenuItem key={plant.id} value={plant.id}>
                {plant.name}
              </MenuItem>
            ))}
          </Select>
        ) : (
          selectedPlant?.name
        )}
      </Typography>
    </Box>
  );
};
